import React from 'react';
import styled from 'styled-components';

const CardStyled = styled.div`
  // border: 1px solid #ccc;
	:hover {
    background-color: #eee;
    cursor: pointer;
  }
`
const MainCard = ({
  ...other
}) => ( <CardStyled {...other}/> )

MainCard.propTypes = {
};

MainCard.defaultProps = {
    
};

export default MainCard;
